const HOME_PAGE_BUNDLE_NAME = 'mach_pro_sailor_c_home_page_main';

/**
 * 处理 Puzzle 预览参数
 */
export const handlePreviewParams = (params: any, url?: string) => {
  const schemeParams = Mach.env?.schemeParams || {};
  if (Mach.env.isDebug && schemeParams?.previewParams) {
    try {
      const previewParams = JSON.parse(schemeParams?.previewParams);
      const bundleName = Mach.env.bundleName;
      /**
       * 首页特化处理：
       * 首页运营区和首页 feeds 流分别对应两个接口
       * 两个接口分别对应不同的页面方案，需要 by 场景透传预览参数
       * 需要根据配置的 api 判断当前接口是否透传
       **/
      if (bundleName === HOME_PAGE_BUNDLE_NAME && previewParams.apiPath) {
        if (previewParams.apiPath.includes(url)) {
          params.previewParams = previewParams;
        } else {
          delete params.previewParams;
        }
      } else {
        params.previewParams = previewParams;
      }
    } catch (error) {
      delete params.previewParams;
    }
  } else {
    delete params.previewParams;
  }
};
